// src/vdr/parserBridge.ts
import type { VDRProviderId, IndexRow } from "./providers";
import { parseIndexFile as parseBasic } from "./basic";
import { parseIndexFile as parseIntralinks } from "./intralinks";
import { parseIndexFile as parseFirmex } from "./firmex";
import { parseIndexFile as parseDataRoom } from "./dataroom";
import { parseIndexFile as parseIdeals } from "./ideals";
import { parseIndexFile as parseSterling } from "./sterling";
import { parseIndexFile as parseRequestList } from "./requestlist";

type Parser = (file: File) => Promise<IndexRow[]>;

/**
 * Register only the providers that are implemented.
 * Add others as you build them.
 */
const REGISTRY: Partial<Record<VDRProviderId, Parser>> = {
  basic: parseBasic,
  intralinks: parseIntralinks,
  firmex: parseFirmex,
  dataroom: parseDataRoom,
  ideals: parseIdeals,
  sterling: parseSterling,
  requestlist: parseRequestList,
};

export async function parseWithProvider(
  provider: VDRProviderId,
  file: File
): Promise<IndexRow[]> {
  const fn = REGISTRY[provider];
  if (!fn) {
    throw new Error(`Parser for provider "${provider}" is not implemented yet.`);
  }
  return fn(file);
}

/** Helper if your UI wants to disable options that aren't implemented yet. */
export function isProviderImplemented(id: VDRProviderId): boolean {
  return Boolean(REGISTRY[id]);
}